import React from 'react';
import PropTypes from 'prop-types';

import NewsletterListSection from './newsletter_list_section';
import SignupWidget from './email_input';
import StickySubmit from './sticky_submit';
import ReCaptcha from './recaptcha';

function NewsletterSignupForm(props) {
  const {
    handleEmailUpdate,
    emailValue,
    disabled,
    handleSignupSubmit,
    placeholder,
    listsDictionary,
    sections,
    state,
    filter,
    transition,
    handleNewslettersUpdate,
    handleNewslettersRadioUpdate,
    hed,
    dek,
    buttonText,
    setFocus,
    toggleInputOn,
    status,
    emailFormError,
    emailUpdateSuccessMessage,
    emailUpdateMessageError,
    subscribedToIds,
    alreadyUsed,
    emailEditable,
    stickySubmit,
    handleStickySubmit,
    handleUnsubscribeAll,
    stickyMessage,
    handleVerify
  } = props;

  return (
    <div className="newsletter-form">
      {hed ? <h2 className="newsletter-form__hed">{hed}</h2> : ''}
      {dek ? <p className="newsletter-form__dek">{dek}</p> : ''}

      <form onSubmit={handleSignupSubmit}>
        <SignupWidget
          handleChange={handleEmailUpdate}
          value={emailValue}
          handleSubmit={handleSignupSubmit}
          disabled={disabled}
          placeholder={placeholder}
          buttonText={buttonText}
          setFocus={setFocus}
          status={status}
          toggleInputOn={toggleInputOn}
          emailFormError={emailFormError}
          emailUpdateSuccessMessage={emailUpdateSuccessMessage}
          emailUpdateMessageError={emailUpdateMessageError}
          emailEditable={emailEditable}
          captcha={
            handleVerify ? (
              <center>
                <ReCaptcha
                  verifyCallback={handleVerify}
                  id="newsletter-signup-page"
                />
              </center>
            ) : (
              ''
            )
          }
        />
        <div className="newsletter-form__groupings">
          {sections.map(section => (
            <NewsletterListSection
              {...{
                key: section.sectionTitle,
                sectionIds: section.ids,
                masterLookup: listsDictionary,
                state,
                sectionTitle: section.sectionTitle,
                filter,
                transition,
                subscribedToIds,
                alreadyUsed,
                handleChange: handleNewslettersUpdate,
                handleNewslettersRadioUpdate
              }}
            />
          ))}
        </div>
        {stickySubmit
          ? [
              <button
                className="newsletter-form__button newsletter-form__button--unsubscribe"
                type="button"
                onClick={handleUnsubscribeAll}
              >
                Unsubscribe from all
              </button>,
              <StickySubmit
                message={stickyMessage}
                handleSubmit={handleStickySubmit}
                handleUnsubscribeAll={handleUnsubscribeAll}
              />
            ]
          : null}
      </form>
    </div>
  );
}

NewsletterSignupForm.defaultProps = {
  filter: true,
  transition: true,
  disabled: false,
  placeholder: 'Your Email',
  buttonText: 'Submit',
  setFocus: () => {},
  toggleInputOn: () => {},
  handleStickySubmit: () => {},
  handleUnsubscribeAll: () => {},
  emailFormError: '',
  emailUpdateSuccessMessage: '',
  emailUpdateMessageError: '',
  subscribedToIds: [],
  status: '',
  alreadyUsed: {},
  emailEditable: true,
  stickySubmit: false,
  stickyMessage: '',
  handleNewslettersRadioUpdate: () => {},
  handleVerify: false
};

NewsletterSignupForm.propTypes = {
  handleEmailUpdate: PropTypes.func.isRequired,
  emailValue: PropTypes.string.isRequired,
  buttonText: PropTypes.string,
  hed: PropTypes.string.isRequired,
  dek: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  handleSignupSubmit: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  listsDictionary: PropTypes.shape({}).isRequired,
  sections: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  state: PropTypes.shape({}).isRequired,
  filter: PropTypes.bool,
  status: PropTypes.string,
  transition: PropTypes.bool,
  handleNewslettersUpdate: PropTypes.func.isRequired,
  setFocus: PropTypes.func,
  toggleInputOn: PropTypes.func,
  emailFormError: PropTypes.string,
  emailUpdateSuccessMessage: PropTypes.string,
  emailUpdateMessageError: PropTypes.string,
  subscribedToIds: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.number, PropTypes.arrayOf(PropTypes.number)])
  ),
  alreadyUsed: PropTypes.shape({}),
  emailEditable: PropTypes.bool,
  stickySubmit: PropTypes.bool,
  handleStickySubmit: PropTypes.func,
  handleUnsubscribeAll: PropTypes.func,
  stickyMessage: PropTypes.string,
  handleNewslettersRadioUpdate: PropTypes.func,
  handleVerify: PropTypes.func
};

export default NewsletterSignupForm;
